import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const postEnquiry = async (type, data) => {
  const response = await axios.post(`${API}/enquiries/${type}`, data);
  return response.data;
};

export const adminLogin = async (email, password) => {
  const response = await axios.post(`${API}/auth/login`, { email, password });
  return response.data;
};

export const registerInterest = async (data) => {
  const response = await axios.post(`${API}/register`, data);
  return response.data;
};

export const getAdminRegistrations = async (token) => {
  const response = await axios.get(`${API}/admin/registrations`, { headers: { Authorization: `Bearer ${token}` } });
  return response.data;
};

export const postPageview = async (data) => {
  const response = await axios.post(`${API}/pageviews`, data);
  return response.data;
};

export const getAdminAnalytics = async (token, days = 30) => {
  const response = await axios.get(`${API}/admin/analytics`, { params: { days }, headers: { Authorization: `Bearer ${token}` } });
  return response.data;
};

export const postLandingVisit = async (data) => {
  const response = await axios.post(`${API}/landing/visit`, data);
  return response.data;
};

export const downloadRegistrationsCsv = async (token) => {
  const response = await axios.get(`${API}/admin/registrations.csv`, { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `lumiere-priority-list-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const getAdminEnquiries = async (token, params = {}) => {
  const response = await axios.get(`${API}/admin/enquiries`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const patchEnquiryHandled = async (token, id, handled) => {
  const response = await axios.patch(`${API}/admin/enquiries/${id}`, { handled }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const getPricing = async () => {
  const response = await axios.get(`${API}/pricing`);
  return response.data;
};

export const putPricing = async (token, pricing) => {
  const response = await axios.put(`${API}/admin/pricing`, pricing, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
